var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendingDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.09761 5.22211C1.36121 4.92922 1.7886 4.92922 2.0522 5.22211L6.2999 9.94178L9.69154 6.17329C9.82675 6.02306 10.013 5.94359 10.2039 5.95463C10.3949 5.96568 10.5727 6.06619 10.6931 6.23121C12.2157 8.31739 13.3991 10.7612 14.1244 13.4849L15.5416 10.7576C15.728 10.3989 16.1408 10.276 16.4636 10.4831C16.7865 10.6902 16.8971 11.1489 16.7107 11.5076L14.4833 15.7942C14.2969 16.153 13.8841 16.2759 13.5612 16.0688L9.70329 13.5939C9.38045 13.3868 9.26983 12.9281 9.45623 12.5694C9.64262 12.2106 10.0554 12.0877 10.3783 12.2949L12.816 13.8586C12.2166 11.6301 11.2876 9.60646 10.1049 7.83529L6.7772 11.5328C6.65061 11.6734 6.47892 11.7524 6.2999 11.7524C6.12088 11.7524 5.94919 11.6734 5.82261 11.5328L1.09761 6.28277C0.834001 5.98988 0.834001 5.515 1.09761 5.22211Z",
    fill: "#E62E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingDownIcon);
export default __webpack_public_path__ + "static/media/trendingDownIcon.730c20a5958f263f01e4f3e5f08295de.svg";
export { ForwardRef as ReactComponent };